import React, { useEffect, useState } from 'react'
import Topbar from '../Navigations/Topbar'
import MainBanner from '../MainBanner'
import NavbarWithCat from '../Navigations/NavbarWithCat'
import Footer from '../../Footer'
import { Link } from 'react-router-dom'
import { apiUrl } from '../../../config'
import { fetchCategory } from '../../../service/CategoryService'

const ProductsGrid = () => {
	const [categories, setCategories] = useState([]);

	const fetchData = async () => {
	const categoriesData = await fetchCategory();
	setCategories(categoriesData);
	};

	useEffect(() => {
	fetchData();
	}, []);
	const styles = {
  productItem: {
    listStyle: "none",
    marginBottom: "30px",
  },
  productInner: {
    background: "#fff",
    borderRadius: "16px",
    overflow: "hidden",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
    position: "relative",
    height: "100%", // so it stretches properly
  },
  flash: {
    background: "#c05c2eff",
    color: "#fff",
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "uppercase",
    padding: "4px 10px",
    borderRadius: "12px",
    position: "absolute",
    top: "12px",
    left: "12px",
    zIndex: 2,
  },
  productThumb: {
    position: "relative",
    textAlign: "center",
    height: "250px",
    overflow: "hidden", // removes border-like background
  },
  productImg: {
    width: "100%",
    height: "100%",
    objectFit: "fill", // fills entire box without extra borders
    transition: "transform 0.3s ease",
  },
  productInfo: {
    padding: "15px",
    textAlign: "center",
  },
  productName: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#222",
    textDecoration: "none",
  },
};
  return (
    <div className='productsgrid-page'>
      <header className="header style7">
	<Topbar/>
</header>
	<div className="main-content main-content-product no-sidebar">
		<div className="container">
			<div className="row pt-4 pb-2">
            <div className="col-lg-12">
              <div className="breadcrumb-trail breadcrumbs">
                <ul className="trail-items breadcrumb">
                  <li className="trail-item trail-begin">
                    <Link to="/" className=" text-decoration-none">Home</Link>
                  </li>
                  <li className="trail-item trail-end active">Categories</li>
                </ul>
              </div>
            </div>
          </div>
			<div className="row">
				<div className="content-area shop-grid-content full-width col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<div className="site-main">
						<h3 className="py-3">
							Categories
						</h3>
						{/* <div className="shop-top-control">
							<form className="select-item select-form">
								<span className="title">Sort</span>
								<select title="sort" data-placeholder="9 Products/Page" className="chosen-select">
									<option value="2">9 Products/Page</option>
									<option value="1">12 Products/Page</option>
									<option value="3">10 Products/Page</option>
									<option value="4">8 Products/Page</option>
									<option value="5">6 Products/Page</option>
								</select>
							</form>
							<form className="filter-choice select-form">
								<span className="title">Sort by</span>
								<select title="sort-by" data-placeholder="Price: Low to High" className="chosen-select">
									<option value="1">Price: Low to High</option>
									<option value="2">Sort by popularity</option>
									<option value="3">Sort by average rating</option>
									<option value="4">Sort by newness</option>
									<option value="5">Sort by price: low to high</option>
								</select>
							</form>
							<div className="grid-view-mode">
								<div className="inner">
									<Link to="/product-list" className="modes-mode mode-list">
										<span></span>
										<span></span>
									</Link>
									<Link to="/product-grid" className="modes-mode mode-grid  active">
										<span></span>
										<span></span>
										<span></span>
										<span></span>
									</Link>
								</div>
							</div>
						</div> */}
						<ul className="row list-products auto-clear equal-container product-grid">
						{categories.map((data, index)=>{
						return <li
                          key={index}
                          style={styles.productItem}
                          className="col-lg-3 col-md-4 col-sm-6 col-12"
                        >
                          <Link to={`/products?categoryId=${data.id}`} style={styles.productName}>
                            <div
                              style={styles.productInner}
                              className="product-inner"
                            >
                              <div className="product-top">
                                <div style={styles.flash}>new</div>
                              </div>
                              <div style={styles.productThumb}>
                                <img
                                  src={apiUrl + '/' + data.imageUrl}
                                  alt="img"
                                  style={styles.productImg}
                                />
                              </div>
                              <div style={styles.productInfo}>
                                <h5 className="product-name">
                                  {data.name}
                                </h5>
                              </div>
                            </div>
                          </Link>
                        </li>
							})}
						</ul>
						{/* <div className="pagination clearfix style2">
							<div className="nav-link">
								<Link to="#" className="page-numbers"><i className="icon fa fa-angle-left" aria-hidden="true"></i></Link>
								<Link to="#" className="page-numbers">1</Link>
								<Link to="#" className="page-numbers">2</Link>
								<Link to="#" className="page-numbers current">3</Link>
								<Link to="#" className="page-numbers"><i className="icon fa fa-angle-right" aria-hidden="true"></i></Link>
							</div>
						</div> */}
					</div>
				</div>
				<div className="sidebar col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<div className="wrapper-sidebar shop-sidebar">
						<div className="widget woof_Widget">
							<div className="widget widget-categories">
								<h3 className="widgettitle">Categories</h3>
								<ul className="list-categories">
									<li>
										<input type="checkbox" id="cb1"/>
										<label for="cb1" className="label-text">
											New Arrivals
										</label>
									</li>
									<li>
										<input type="checkbox" id="cb2"/>
										<label for="cb2" className="label-text">
											Earrings
										</label>
									</li>
									<li>
										<input type="checkbox" id="cb3"/>
										<label for="cb3" className="label-text">
											Tanzanites
										</label>
									</li>
									<li>
										<input type="checkbox" id="cb4"/>
										<label for="cb4" className="label-text">
											Bracelets
										</label>
									</li>
									<li>
										<input type="checkbox" id="cb5"/>
										<label for="cb5" className="label-text">
											Accessories
										</label>
									</li>
									<li>
										<input type="checkbox" id="cb6"/>
										<label for="cb6" className="label-text">
											By Metal
										</label>
									</li>
								</ul>
							</div>
							<div className="widget widget_filter_price">
								<h4 className="widgettitle">
									Price
								</h4>
								<div className="price-slider-wrapper">
		                    		<div data-label-reasult="Range:" data-min="0" data-max="3000" data-unit="$" className="slider-range-price " data-value-min="0" data-value-max="1000">	
		                    		</div>
		                    		<div className="price-slider-amount">
			                            <span className="from">$45</span>
			                            <span className="to">$215</span>
			                        </div>
								</div>
							</div>
							<div className="widget widget-brand">
								<h3 className="widgettitle">Brand</h3>
								<ul className="list-brand">
									<li>
										<input id="cb7" type="checkbox"/>
										<label for="cb7" className="label-text">New Arrivals</label>
									</li>
									<li>
										<input id="cb8" type="checkbox"/>
										<label for="cb8" className="label-text">Earrings</label>
									</li>
									<li>
										<input id="cb9" type="checkbox"/>
										<label for="cb9" className="label-text">Tanzanites</label>
									</li>
									<li>
										<input id="cb10" type="checkbox"/>
										<label for="cb10" className="label-text">Bracelets</label>
									</li>
									<li>
										<input id="cb11" type="checkbox"/>
										<label for="cb11" className="label-text">Accessories</label>
									</li>
									<li>
										<input id="cb12" type="checkbox"/>
										<label for="cb12" className="label-text">By Metal</label>
									</li>
								</ul>
							</div>
							<div className="widget widget_filter_size">
								<h4 className="widgettitle">Size</h4>
								<ul className="list-brand">
									<li>
										<input id="cb13" type="checkbox"/>
										<label for="cb13" className="label-text">14.0 mm</label>
									</li>
									<li>
										<input id="cb14" type="checkbox"/>
										<label for="cb14" className="label-text">14.4 mm</label>
									</li>
									<li>
										<input id="cb15" type="checkbox"/>
										<label for="cb15" className="label-text">14.8 mm</label>
									</li>
									<li>
										<input id="cb16" type="checkbox"/>
										<label for="cb16" className="label-text">15.2 mm</label>
									</li>
									<li>
										<input id="cb17" type="checkbox"/>
										<label for="cb17" className="label-text">15.6 mm</label>
									</li>
									<li>
										<input id="cb18" type="checkbox"/>
										<label for="cb18" className="label-text">16.0 mm</label>
									</li>
								</ul>
							</div>
							<div className="widget widget-color">
								<h4 className="widgettitle">
									Color
								</h4>
								<div className="list-color">
									<Link to="#" className="color1"></Link>
									<Link to="#" className="color2 "></Link>
									<Link to="#" className="color3 active"></Link>
									<Link to="#" className="color4"></Link>
									<Link to="#" className="color5"></Link>
									<Link to="#" className="color6"></Link>
									<Link to="#" className="color7"></Link>
								</div>
							</div>
							<div className="widget widget-tags">
								<h3 className="widgettitle">
									Popular Tags
								</h3>
								<ul className="tagcloud">
									<li className="tag-cloud-link">
										<Link to="#">Pendants</Link>
									</li>
									<li className="tag-cloud-link">
										<Link to="#">Bracelets</Link>
									</li>
									<li className="tag-cloud-link">
										<Link to="#">Flowering</Link>
									</li>
									<li className="tag-cloud-link active">
										<Link to="#">Accessories</Link>
									</li>
									<li className="tag-cloud-link">
										<Link to="#">Hot</Link>
									</li>
									<li className="tag-cloud-link">
										<Link to="#">By Metal</Link>
									</li>
									<li className="tag-cloud-link">
										<Link to="#">Earrings</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="widget newsletter-widget">
							<div className="newsletter-form-wrap ">
								<h3 className="title">Subscribe to Our Newsletter</h3>
								<div className="subtitle">
									More special Deals, Events & Promotions
								</div>
								<input type="email" className="email" placeholder="Your email letter"/>
								<button type="submit" className="button submit-newsletter">Subscribe</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    <Footer/>
	<div className="footer-device-mobile">
		<div className="wapper">
			<div className="footer-device-mobile-item device-home">
				<Link to="index.html">
					<span className="icon">
						<i className="fa fa-home" aria-hidden="true"></i>
					</span>
					Home
				</Link>
			</div>
			<div className="footer-device-mobile-item device-home device-wishlist">
				<Link to="#">
					<span className="icon">
						<i className="fa fa-heart" aria-hidden="true"></i>
					</span>
					Wishlist
				</Link>
			</div>
			<div className="footer-device-mobile-item device-home device-cart">
				<Link to="#">
					<span className="icon">
						<i className="fa fa-shopping-basket" aria-hidden="true"></i>
						<span className="count-icon">
							0
						</span>
					</span>
					<span className="text">Cart</span>
				</Link>
			</div>
			<div className="footer-device-mobile-item device-home device-user">
				<Link to="#">
					<span className="icon">
						<i className="fa fa-user" aria-hidden="true"></i>
					</span>
					Account
				</Link>
			</div>
		</div>
	</div>
	<Link to="#" className="backtotop">
		<i className="fa fa-angle-double-up"></i>
	</Link>
    </div>
  )
}

export default ProductsGrid